/**
 * test input value is string or not
 * @param {*} value
 * @returns {boolean}
 */
export default function isString(value) {
  return typeof value === 'string';
}
